import { IClassname } from '@/lib/shared/model/classname';

export const FilterGym = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.82617 11.1738H13.1739"
        stroke="white"
        strokeWidth="1.6"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M5.34807 5.08691H7.95674C7.95674 5.08691 8.82629 5.08691 8.82629 5.95647V15.5216C8.82629 15.5216 8.82629 16.3911 7.95674 16.3911H5.34807C5.34807 16.3911 4.47852 16.3911 4.47852 15.5216V5.95647C4.47852 5.95647 4.47852 5.08691 5.34807 5.08691Z"
        stroke="white"
        strokeWidth="1.6"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M4.47829 7.69531H2.73918C2.50856 7.69531 2.28739 7.78693 2.12432 7.95C1.96124 8.11307 1.86963 8.33425 1.86963 8.56487V12.9126C1.86963 13.1433 1.96124 13.3644 2.12432 13.5275C2.28739 13.6906 2.50856 13.7822 2.73918 13.7822H4.47829"
        stroke="white"
        strokeWidth="1.6"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M1.86956 10.7393H1"
        stroke="white"
        strokeWidth="1.6"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M14.0434 5.08691H16.652C16.652 5.08691 17.5216 5.08691 17.5216 5.95647V15.5216C17.5216 15.5216 17.5216 16.3911 16.652 16.3911H14.0434C14.0434 16.3911 13.1738 16.3911 13.1738 15.5216V5.95647C13.1738 5.95647 13.1738 5.08691 14.0434 5.08691Z"
        stroke="white"
        strokeWidth="1.6"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M17.5215 7.69531H19.2606C19.4912 7.69531 19.7124 7.78693 19.8755 7.95C20.0385 8.11307 20.1302 8.33425 20.1302 8.56487V12.9126C20.1302 13.1433 20.0385 13.3644 19.8755 13.5275C19.7124 13.6906 19.4912 13.7822 19.2606 13.7822H17.5215"
        stroke="white"
        strokeWidth="1.6"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M20.1304 10.7393H20.9999"
        stroke="white"
        strokeWidth="1.6"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
    </svg>
  );
};
